import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './PhoneInputSafari.html?raw';

import _LabelInputBase from '../../_LabelInputBase/_LabelInputBase';
import lang from 'dojo/_base/lang';
import { AccessibilityLabelsHelper } from "../../../../more/Helpers";

class PhoneInputSafari extends compose(_LabelInputBase) {
    private generousPhoneRegex: any = /^(\+)?[\d\s\(\)-]{5,}$/;
    templateString: any = template;
    onlyCountries: Array<string> = []; //ignored
    excludeCountries: Array<string> = []; //ignored
    preferredCountries: Array<string> = []; //ignored
    initialCountry: string; //ignored

    errorMsgNode:HTMLDivElement;
    labelNode:HTMLLabelElement;
    inputNode:HTMLInputElement;

    private supressEv = false;
    validationEnabled: boolean = true;
    private errorMessages: any = {
        invalidFormat: window.translations['PersonData__phoneValidationMsg_invalid'],
        required: "Phone number is required"
    };

    getInitialCountry(): string {
        return "";
    }
    setInitialCountry(country: string): void {
        //ignored
    }
    setOnlyCountries(onlyCountries: Array<String>): void {
        //ignored
    }
    getOnlyCountries(): Array<String> | undefined {
        return undefined;
    }
    setExcludeCountries(onlyCountries: Array<String>): void {
        //ignored
    }
    getExcludeCountries(): Array<String> | undefined {
        return undefined;
    }
    setPreferredCountries(onlyCountries: Array<String>): void {
        //ignored
    }
    getPreferredCountries(): Array<String> | undefined {
        return undefined;  //ignored
    }
    getExtension(): string | null {
        return null; //ist irgendwie immer null
    }
    getNumberType(): number | null {
        return 11; // 11 = unknown https://libphonenumbers.js.org/docs/getNumberType/
    }
    getSelectedCountryData(): object | null {
        return null;
    }
    isValidNumber(): boolean {
        if (!this._value || this._value.trim() === "") {
            return false;
        }
        return this.generousPhoneRegex.test(this._value);
    }
    setCountry(iso2: string): void {
        //ignored
    }
    getNumber(): string | null {
        return this._value;
    }
    setPlaceholderNumberType(numberType: string): void {
        // ignored, not applicable
    }
    setValidationEnabled(bEnable?: boolean): void {
        this.validationEnabled = bEnable;
    }
    getDocumentationContent(): string {
        return "";
    }

    setValue(newValue: any, suppressChangeEvent?: boolean): void {
        if ((suppressChangeEvent ?? false) == true){
            this.supressEv = true;
        }
        this.inputNode.value = newValue;
        this._value = newValue;
        if ((suppressChangeEvent ?? false) == true) {
            this.supressEv = false;
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        if (typeof window["flag_safariBug"] != 'boolean'){
            window["flag_safariBug"] = true;
            this.showToast(this.translate("SafariBug_TelInputJs"), "fab fa-safari")
        }
        this.inputNode.addEventListener('change', lang.hitch(this, this._onChange_InputNode));
        this.inputNode.addEventListener('blur', lang.hitch(this, this._validateInput));

        AccessibilityLabelsHelper.LabelForInputBind(this.id, this.inputNode, "telInput", this.labelNode);
    }

    private _onChange_InputNode(ev:Event){
        if (this.supressEv == true){
            return;
        }
        this._value = this.inputNode.value;
        this.emit("valueChange", this._value);
        this.emit("change", this._value);
        this._validateInput();
    }

    private _validateInput(): void {
        if (this.supressEv == true) {
            return;
        }
        if (!this.validationEnabled) {
            return;
        }

        const isValid = this.isValidNumber();

        if (this.errorMsgNode) {
            if (isValid) {
                this.errorMsgNode.textContent = "";
                this.errorMsgNode.style.display = "none";
            } else {
                const errorMsg = this.errorMessages.invalidFormat
                this.errorMsgNode.textContent = errorMsg;
                this.errorMsgNode.style.display = "block";
            }
        }
    }
}

export default mdsWidget(PhoneInputSafari);
